module.exports = __webpack_public_path__ + "static/media/link.27b7a88a.svg";